import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ocm-body1 mx-auto max-w-82" }
const _hoisted_2 = { class: "ocm-headline3 mb-4" }
const _hoisted_3 = { class: "mb-10 grid gap-y-2" }
const _hoisted_4 = { class: "grid grid-cols-[min-content,1fr] gap-x-3" }
const _hoisted_5 = { class: "grid grid-cols-[min-content,1fr] gap-x-3" }
const _hoisted_6 = { class: "grid grid-cols-[min-content,1fr] gap-x-3" }

import { ref, useTemplateRef, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import AccessibleModal from "@SharedVueComponents/Modal/AccessibleModal.vue";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import SharedButton from "@SharedVueComponents/SharedButton.vue";
import pushDataLayer from "@ocm/services/dataLayer";
import { resourcesHostname, commonResourcePath } from "@ocm/services/ocm-object";


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeModal',
  setup(__props) {

const { t } = useI18n();

const IMAGE_URL = `${resourcesHostname}${commonResourcePath}/images/welcome/2023-herbst-casual-triple-02-web.jpg`;

let closeAction = "Closed";
const trackModal = (action: string = closeAction) => {
	const category = "S_WelcomeLayer";
	pushDataLayer({
		event: "GAevent",
		event_category: category,
		event_action: `${category}${action}`,
		event_label: "",
	});
};

const trackRegistrationCompleted = () => {
	pushDataLayer({
		event: "registrationFunnel",
		funnelStep: "completedRegistration",
	});
};

const dialogEl = useTemplateRef<InstanceType<typeof AccessibleModal>>("dialogEl");
const closeModal = () => {
	closeAction = "Button";
	dialogEl.value?.close();
};

const hasWelcomeModal = ref(false);
onMounted(async () => {
	if (!window.sessionStorage.getItem("registrationCompleted")) return;

	window.sessionStorage.removeItem("registrationCompleted");
	trackRegistrationCompleted();
	hasWelcomeModal.value = true;
	await nextTick();
	dialogEl.value?.open();
	trackModal("Shown");
});

return (_ctx: any,_cache: any) => {
  return (hasWelcomeModal.value)
    ? (_openBlock(), _createBlock(AccessibleModal, {
        key: 0,
        ref_key: "dialogEl",
        ref: dialogEl,
        headline: _unref(t)('siteWide.welcomeModal.headline'),
        onClosed: _cache[0] || (_cache[0] = ($event: any) => (trackModal()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "mb-6",
              src: IMAGE_URL,
              width: "328",
              height: "164",
              alt: ""
            }),
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("siteWide.welcomeModal.subline")), 1),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", _hoisted_4, [
                _createVNode(SvgIcon, {
                  "icon-name": "heart-empty",
                  class: "size-5"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("siteWide.welcomeModal.benefit1")), 1)
              ]),
              _createElementVNode("li", _hoisted_5, [
                _createVNode(SvgIcon, {
                  "icon-name": "gutscheine",
                  class: "size-5"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("siteWide.welcomeModal.benefit2")), 1)
              ]),
              _createElementVNode("li", _hoisted_6, [
                _createVNode(SvgIcon, {
                  "icon-name": "club-small",
                  class: "size-5"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("siteWide.welcomeModal.benefit3")), 1)
              ])
            ]),
            _createVNode(SharedButton, {
              class: "w-full",
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("siteWide.welcomeModal.button")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["headline"]))
    : _createCommentVNode("", true)
}
}

})